import { useEffect } from 'react';
import { hologramSceneStore, setVeilPanel } from './hologramSceneStore';

// 쥠 250ms + 돌려 넘김 1150ms. 메인으로 넘어가는 시각(useStepTransition 의 800ms)은 그대로라
// 남은 600ms 는 메인 화면의 광원장이 같은 store 를 읽어 마저 넘긴다.
export const REVEAL_SWEEP_MS = 1400;

// 로그아웃 때 베일을 다시 내리는 시간. 넘길 때와 달리 모달을 싣지 않아 쥠이 없다.
export const CONCEAL_SWEEP_MS = 1000;

// 진행 중인 넘김. 화면이 바뀌어도(로그인 → 메인) 끝까지 가야 해서 컴포넌트 밖에 둔다.
let sweepRaf = 0;
// 끊긴 넘김을 기다리던 쪽(로그아웃)이 멈추지 않도록 끊을 때도 부른다.
let sweepDone: (() => void) | null = null;

function stopSweep() {
  if (sweepRaf) cancelAnimationFrame(sweepRaf);
  sweepRaf = 0;
  const done = sweepDone;
  sweepDone = null;
  done?.();
}

function runSweep(to: number, ms: number, onDone?: () => void) {
  stopSweep();
  sweepDone = onDone ?? null;
  const from = hologramSceneStore.reveal;
  let start = -1;
  const tick = (now: number) => {
    if (start < 0) start = now;
    // 선형으로 넘긴다 — 쥠·스냅의 곡선은 셰이더(veilComposite)가 준다
    const t = Math.min(1, (now - start) / ms);
    hologramSceneStore.reveal = from + (to - from) * t;
    if (t < 1) {
      sweepRaf = requestAnimationFrame(tick);
    } else {
      sweepRaf = 0;
      setVeilPanel(null);
      const done = sweepDone;
      sweepDone = null;
      done?.();
    }
  };
  sweepRaf = requestAnimationFrame(tick);
}

/** 로그아웃 — 걷혔던 베일을 다시 내려 광원장을 설계도로 되돌린다. 로그인 화면의 대기 모습과 같다. */
export function concealLuminarium(): Promise<void> {
  setVeilPanel(null);
  return new Promise((resolve) => runSweep(0, CONCEAL_SWEEP_MS, resolve));
}

/**
 * 광원장을 설계도(와이어프레임)로 보이다가 exiting 이 켜지면 베일을 들어 넘겨 렌더로 연다.
 * store 는 모듈 싱글턴이라 넘기지 않고 떠날 때는 1 로 되돌린다 — 안 그러면 다음 화면이 설계도로 남는다.
 */
export function useLuminariumReveal(exiting: boolean, noMotion: boolean) {
  useEffect(() => {
    stopSweep();
    hologramSceneStore.reveal = noMotion ? 1 : 0;
    return () => {
      if (sweepRaf) return;
      hologramSceneStore.reveal = 1;
      setVeilPanel(null);
    };
  }, [noMotion]);

  useEffect(() => {
    if (!exiting) return;
    if (noMotion) {
      hologramSceneStore.reveal = 1;
      setVeilPanel(null);
      return;
    }
    runSweep(1, REVEAL_SWEEP_MS);
  }, [exiting, noMotion]);
}
